import React from 'react';
import classNames from 'classnames';
import { SectionTilesProps } from '../../utils/SectionProps';
import SectionHeader from './partials/SectionHeader';
import Image from '../elements/Image';

const propTypes = {
  ...SectionTilesProps.types
}

const defaultProps = {
  ...SectionTilesProps.defaults
}
const FeaturesTiles = ({
  className,
  topOuterDivider,
  bottomOuterDivider,
  topDivider,
  bottomDivider,
  hasBgColor,
  invertColor,
  pushLeft,
  ...props
}) => {

  const outerClasses = classNames(
    'features-tiles section',
    topOuterDivider && 'has-top-divider',
    bottomOuterDivider && 'has-bottom-divider',
    hasBgColor && 'has-bg-color',
    invertColor && 'invert-color',
    className
  );

  const innerClasses = classNames(
    'features-tiles-inner section-inner',
    topDivider && 'has-top-divider',
    bottomDivider && 'has-bottom-divider'
  );

  const tilesClasses = classNames(
    'tiles-wrap center-content',
    pushLeft && 'push-left'
  );

  const sectionHeader = {
    title: 'Skillset and Services',
    paragraph: 'Engineered solutions that fit your needs'
  };

  return (
    <section
      {...props}
      className={outerClasses}
    >
      <div className="container">
        <div className={innerClasses}>
          <SectionHeader data={sectionHeader} className="center-content" />
          <div className={tilesClasses}>

            <div className="tiles-item reveal-from-bottom">
              <div className="tiles-item-inner">
                <div className="features-tiles-item-header">
                  <div className="features-tiles-item-image mb-16">
                    <Image
                      src={require('./../../assets/images/feature-tile-icon-01.svg')}
                      alt="Features tile icon 01"
                      width={64}
                      height={64} />
                  </div>
                </div>
                <div className="features-tiles-item-content">
                  <h4 className="mt-0 mb-8">
                    Asset Management
                    </h4>
                  <p className="m-0 text-sm">
                  <li> Risk Attribution Report</li>
                  <li> Liquitidy Report</li>
                  <li> Fundamental Factor Model</li>
                  <li> Macroeconomic Factor Model</li>
                  <li> Manager Selection and Alternative Investments </li>

                    </p>
                </div>
              </div>
            </div>

            <div className="tiles-item reveal-from-bottom" data-reveal-delay="200">
              <div className="tiles-item-inner">
                <div className="features-tiles-item-header">
                  <div className="features-tiles-item-image mb-16">
                    <Image
                      src={require('./../../assets/images/feature-tile-icon-02.svg')}
                      alt="Features tile icon 02"
                      width={64}
                      height={64} />
                  </div>
                </div>
                <div className="features-tiles-item-content">
                  <h4 className="mt-0 mb-8">
                    Trading
                    </h4>
                  <p className="m-0 text-sm">
                  <li> Equity Derivatives and FX trader </li>
                  <li> Electronic Market Making  </li>
                  <li> Signal and Alpha generation </li>
                  <li> Exotic Pricing using Numerical Methods and Monte Carlo </li>
                  <li> Index Rebalancing Arbitrage and Carry </li>
                  <li> FINRA Series 3, Series 7, Series 55, Series 63 </li>
                    </p>
                </div>
              </div>
            </div>

            <div className="tiles-item reveal-from-bottom" data-reveal-delay="400">
              <div className="tiles-item-inner">
                <div className="features-tiles-item-header">
                  <div className="features-tiles-item-image mb-16">
                    <Image
                      src={require('./../../assets/images/feature-tile-icon-03.svg')}
                      alt="Features tile icon 03"
                      width={64}
                      height={64} />
                  </div>
                </div>
                <div className="features-tiles-item-content">
                  <h4 className="mt-0 mb-8">
                    adTech and eMarketing
                    </h4>
                  <p className="m-0 text-sm">
                    <li> RealTimeBidding auction strategies </li>
                    <li> Systematic Machine Learning strategy </li>
                    <li> Tens of TB of data stored daily </li>
                    <li> Largest Hadoop clusters with 171 PB of storage and 42.000 cores </li>
                    </p>
                </div>
              </div>
            </div>

            <div className="tiles-item reveal-from-bottom">
              <div className="tiles-item-inner">
                <div className="features-tiles-item-header">
                  <div className="features-tiles-item-image mb-16">
                    <Image
                      src={require('./../../assets/images/feature-tile-icon-04.svg')}
                      alt="Features tile icon 04"
                      width={64}
                      height={64} />
                  </div>
                </div>
                <div className="features-tiles-item-content">
                  <h4 className="mt-0 mb-8">
                    ML and Statistical Methods
                    </h4>
                  <p className="m-0 text-sm">
                  <li> Feature Engineering: Khi2, Gini Information, Entropy, Fisher Information</li>
                  <li> Statistical Significance Testing and Bootstrapping</li>
                  <li> A/B test, population sampling </li>
                  <li> AI and Machine Learning Models for Prediction </li>
                  <li> NeurIPS</li>
                    </p>
                </div>
              </div>
            </div>

            <div className="tiles-item reveal-from-bottom" data-reveal-delay="200">
              <div className="tiles-item-inner">
                <div className="features-tiles-item-header">
                  <div className="features-tiles-item-image mb-16">
                    <Image
                      src={require('./../../assets/images/feature-tile-icon-05.svg')}
                      alt="Features tile icon 05"
                      width={64}
                      height={64} />
                  </div>
                </div>
                <div className="features-tiles-item-content">
                  <h4 className="mt-0 mb-8">
                    Technologies
                    </h4>
                  <p className="m-0 text-sm">
                  <li> Hadoop, Spark, Tensorflow </li>
                  <li> Google Cloud Platform, Heroku, GitHub </li>
                  <li> Full Stack DevOps: Django, Flatter and React</li>
                  <li> Python, SQL, C++, HTML, CSS, js </li>
                  <li> JupyterNotebook, pyCharm</li>
                  <li> Mac, Linux, Cherry MX Brown</li>
                    </p>
                </div>
              </div>
            </div>

            <div className="tiles-item reveal-from-bottom" data-reveal-delay="400">
              <div className="tiles-item-inner">
                <div className="features-tiles-item-header">
                  <div className="features-tiles-item-image mb-16">
                    <Image
                      src={require('./../../assets/images/feature-tile-icon-06.svg')}
                      alt="Features tile icon 06"
                      width={64}
                      height={64} />
                  </div>
                </div>
                <div className="features-tiles-item-content">
                  <h4 className="mt-0 mb-8">
                    Others
                    </h4>
                  <p className="m-0 text-sm">
                  <li> Public Speaking </li>
                  <li> Native in French and Arabic, Fluent in English, Intermediate in Spanish</li>
                  <li> Read FT on a daily basis for the past decade</li>
                  <li> Logic Pro, MIDI and Mic </li>
                    </p>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>
    </section>
  );
}

FeaturesTiles.propTypes = propTypes;
FeaturesTiles.defaultProps = defaultProps;

export default FeaturesTiles;
